import React from "react";
import { TableCell } from "@mui/material";

function TableHeaderAdv(
  Field,
  function_handleHeaderClickAdv,
  sortField,
  sortNest
) {
  return (
    <TableCell
      className="tableCellHeader" // Add this line to include the CSS class
      align="left"
      style={{
        position: "sticky",
        Top: 0,
        zIndex: 1,
        fontWeight: "bold", // Make Text bold
        padding: "8px", // Adjust padding as needed To make cells smaller
      }}
      onClick={() => function_handleHeaderClickAdv(sortField, sortNest)}
    >
      {Field}
    </TableCell>
  );
}

export default TableHeaderAdv;
